import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const Card = styled.div`
  background: ${vimovaTheme.colors.white};
  border-radius: ${vimovaTheme.borderRadius.signature};
  border: 1px solid ${vimovaTheme.colors.border};
  padding: 24px;
  box-sizing: border-box;

  @media print {
    background: ${vimovaTheme.colors.white} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    padding: 24px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const CardHighlight = styled.div`
  background: ${vimovaTheme.colors.white};
  border-radius: ${vimovaTheme.borderRadius.signature};
  border: 1px solid ${vimovaTheme.colors.border};
  padding: 24px;
  box-sizing: border-box;
  box-shadow: ${vimovaTheme.shadows.card};

  @media print {
    background: ${vimovaTheme.colors.white} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    padding: 24px !important;
    box-shadow: ${vimovaTheme.shadows.card} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricCard = styled.div`
  background: ${vimovaTheme.colors.white};
  border-radius: ${vimovaTheme.borderRadius.signature};
  border: 1px solid ${vimovaTheme.colors.border};
  padding: 16px;
  box-sizing: border-box;
  text-align: center;

  @media print {
    background: ${vimovaTheme.colors.white} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    padding: 16px !important;
    text-align: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PriceDisplay = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-weight: ${vimovaTheme.fontWeights.bold};
  color: ${vimovaTheme.colors.green};
  font-size: ${vimovaTheme.fontSizes.title};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    color: ${vimovaTheme.colors.green} !important;
    font-size: ${vimovaTheme.fontSizes.title} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
